import GSAPInit from "../../../Animations/GSAP";

/*
export default {
    CouvertureViewArticle: (target, yAnim, speed = 0.4) => {
        if(target === null) return;

        TweenMax
            .to(target, speed, { y: yAnim, rotation: 0.0001, ease: Power3.easeInOut })

    },
    CouvertureViewCouverture: (target, speed = 0.4) => {
        if(target === null) return;

        TweenMax
            .to(target, speed, { y: 0, rotation: 0.0001, ease: Power3.easeInOut })

    },
    CouvertureViewTitle: (target, speed = 0.4) => {
        if(target === null) return;

        const timeline = new TimelineMax();

        timeline
            .fromTo(target, speed, { y: 0, autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, (speed !== 0) ? "+=0.2" : "+=0")

    },
    setCouvertureViewBtn: (target, direction) => {
        if(target === null) return;

        if(direction === "couverture"){
            TweenMax.set(target, { autoAlpha: 1 }, "+=0.3")
        } else if(direction === "article"){
            TweenMax.set(target, { autoAlpha: 0 }, "+=0.3")
        }
    },
    CouvertureViewBtn: (target, direction) => {
        if(target === null) return;

        if(direction === "couverture"){
            TweenMax.to(target, 0.3, { autoAlpha: 1 }, "+=0.3")
        } else if(direction === "article"){
            TweenMax.to(target, 0.3, { autoAlpha: 0 }, "+=0.3")
        }
    },
    CouvertureViewImageArticle: (target, yAnim, speed = 0.4) => {
        if(target === null) return;

        TweenMax.to(target, speed, { y: yAnim * -1, rotation: 0.0001, ease: Power3.easeInOut });
    },
    CouvertureViewImageCouverture: (target, speed = 0.4) => {
        if(target === null) return;

        const timeline = new TimelineMax();

        TweenMax.to(target, speed, { y: 0, rotation: 0.0001, ease: Power3.easeInOut });

    },
    animationViewImagesIn: (imageTarget1, imageTarget2, speed) => {
        if(imageTarget1 === null || imageTarget2 === null) return;

        const timeline = new TimelineMax();

        timeline
            .fromTo(imageTarget1, speed, { autoAlpha: 0}, { autoAlpha: 1 }, "+=0.4")
            .fromTo(imageTarget2, speed, { autoAlpha: 1}, { autoAlpha: 0 }, "-=" + speed)

    }
};
*/

class GsapComponent {

    CouvertureViewArticle= (gsap, target, yAnim, speed = 0.4) => {
        if(target === null || !gsap) return;

        gsap.TweenMax
            .to(target, speed, { y: 0, rotation: 0.0001, ease: gsap.Power3.easeInOut });

    };

    CouvertureViewCouverture= (gsap, target, speed = 0.4) => {
        if(target === null || !gsap) return;

        gsap.TweenMax
            .to(target, speed, { y: 0, rotation: 0.0001, ease: gsap.Power3.easeInOut });

    };
    CouvertureViewTitle= (gsap, target, speed = 0.4) => {
        if(target === null || !gsap) return;

        const timeline = new gsap.TimelineMax();

        timeline
            .fromTo(target, speed, { y: 0, autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, (speed !== 0) ? "+=0.2" : "+=0")

    };
    setCouvertureViewBtn= (gsap, target, direction) => {
        if(target === null || !gsap) return;

        if(direction === "couverture"){
            gsap.TweenMax.set(target, { autoAlpha: 1 }, "+=0.3")
        } else if(direction === "article"){
            gsap.TweenMax.set(target, { autoAlpha: 0 }, "+=0.3")
        }
    };
    CouvertureViewBtn= (gsap, target, direction) => {
        if(target === null || !gsap) return;

        if(direction === "couverture"){
            gsap.TweenMax.to(target, 0.3, { autoAlpha: 1 }, "+=0.3")
        } else if(direction === "article"){
            gsap.TweenMax.to(target, 0.3, { autoAlpha: 0 }, "+=0.3")
        }

    };
    CouvertureViewImageArticle= (gsap, target, yAnim, speed = 0.4) => {
        if(target === null || !gsap) return;

        gsap.TweenMax.to(target, speed, { y: yAnim * -1, rotation: 0.0001, ease: gsap.Power3.easeInOut });
    };
    CouvertureViewImageCouverture= (gsap, target, speed = 0.4) => {
        if(target === null || !gsap) return;

        const timeline = new gsap.TimelineMax();

        gsap.TweenMax.to(target, speed, { y: 0, rotation: 0.0001, ease: gsap.Power3.easeInOut });

    };
    animationViewImagesIn= (gsap, imageTarget1, imageTarget2, speed) => {
        if(!gsap) return;
        if(imageTarget1 === null || imageTarget2 === null) return;

        const timeline = new gsap.TimelineMax();

        // timeline
        //     .fromTo(imageTarget1, speed, { autoAlpha: 0 }, { autoAlpha: 1 }, "+=0.4")
        //     .fromTo(imageTarget2, speed, { autoAlpha: 1 }, { autoAlpha: 0 }, "-=" + speed)

        let img = new Image();

        img.onload = function () {
            timeline
             .fromTo(imageTarget1, speed, { autoAlpha: 0 }, { autoAlpha: 1 })
             .fromTo(".fx-img", 0.3, { autoAlpha: 0 }, { autoAlpha: 1 }, "-=0.6");
        };

        img.src = imageTarget2.src;

        timeline
            //.fromTo(imageTarget1, speed, { autoAlpha: 1 }, { autoAlpha: 1 }, "+=0.1")
            .fromTo(imageTarget2, speed, { autoAlpha: 1 }, { autoAlpha: 0 }, "-=" + speed)
            .fromTo(".fx-img", 0.1, { autoAlpha: 1 }, { autoAlpha: 0 }, "-=0.5")
            //.fromTo(".fx-img", speed, { autoAlpha: 1 }, { autoAlpha: 0 }, "-=" + speed)
            .fromTo(document.querySelector(".article-couverture .inner"), 0.7, {
                autoAlpha: 0,rotation: 0.0001, ease: gsap.Power3.easeInOut
            }, {
                autoAlpha: 1,rotation: 0.0001, ease: gsap.Power3.easeInOut
            }, "-=0.35");

    };
    animationViewImageInAsync = (gsap, image, speed) => {
        if(!gsap) return;
        if(image === null) return;

        const timeline = new gsap.TimelineMax();

        /*console.log()

        timeline
            .fromTo(image, speed, { autoAlpha: 0 }, { autoAlpha: 1 }, "+=0.1")
            .fromTo(".fx-img", 0.3, { autoAlpha: 0 }, { autoAlpha: 1 }, "-=0.5")
            */

    };


}


let gsap = new GsapComponent();
let gsapInit = new GSAPInit();

export default {
    CouvertureViewArticle: (target, yAnim, speed) => {
        gsapInit.importGSAP().then((module) => {
            gsap.CouvertureViewArticle(module, target, yAnim, speed)
        });
    },
    CouvertureViewCouverture: (target, speed) => {
        gsapInit.importGSAP().then((module) => {
            gsap.CouvertureViewCouverture(module, target, speed)
        });
    },
    CouvertureViewTitle: (target, speed) => {
        gsapInit.importGSAP().then((module) => {
            gsap.CouvertureViewTitle(module, target, speed)
        });
    },
    setCouvertureViewBtn: (target, direction) => {
        gsapInit.importGSAP().then((module) => {
            gsap.setCouvertureViewBtn(module, target, direction)
        });
    },
    CouvertureViewBtn: (target, direction) => {
        gsapInit.importGSAP().then((module) => {
            gsap.CouvertureViewBtn(module, target, direction)
        });
    },
    cardAnimation: (target) => {
        gsapInit.importGSAP().then((module) => {
            gsap.cardAnimation(module, target)
        });
    },
    CouvertureViewImageArticle: (target, yAnim, speed) => {
        gsapInit.importGSAP().then((module) => {
            gsap.CouvertureViewImageArticle(module, target, yAnim, speed)
        });
    },
    CouvertureViewImageCouverture: (target, speed) => {
        gsapInit.importGSAP().then((module) => {
            gsap.CouvertureViewImageCouverture(module, target, speed)
        });
    },
    animationViewImagesIn: (imageTarget1, imageTarget2, speed) => {
        gsapInit.importGSAP().then((module) => {
            gsap.animationViewImagesIn(module, imageTarget1, imageTarget2, speed)
        });
    },
    animationViewImageInAsync: (image, speed) => {
        gsapInit.importGSAP().then((module) => {
            gsap.animationViewImageInAsync(module, image, speed)
        });
    }
};
